import { Dialog, Button } from '@mui/material';

interface TwoBtnAlertProps {
  open: boolean;
  onClose: () => void;
  title: string;
  content: string;
  leftBtnText?: string;
  rightBtnText?: string;
  leftBtnClick: () => void;
  rightBtnClick: () => void;
}

export default function TwoBtnAlert({
  open,
  onClose,
  title,
  content,
  leftBtnText = 'Cancel',
  rightBtnText = 'Confirm',
  leftBtnClick,
  rightBtnClick,
}: TwoBtnAlertProps) {
  return (
    <Dialog
      open={open}
      onClose={(reason: any) => {
        if (reason === 'backdropClick') return;
        onClose();
      }}
      PaperProps={{
        sx: {
          borderRadius: '16px',
          maxWidth: 'calc(100vw - 40px)',
          width: '100%',
          margin: '20px',
        },
      }}
      sx={{
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
        zIndex: 9999,
      }}
    >
      <div className="w-full bg-white rounded-[16px] p-[24px] flex flex-col gap-[32px]">
        <div className="w-full flex flex-col items-center justify-center gap-[12px]">
          <div className="text-[20px] font-[700] text-center text-[#1C1C1C] leading-[1.3] break-keep whitespace-pre-wrap">
            {title.split('\n').map((line, i) => (
              <span key={i}>
                {line}
                {i === 0 && <br />}
              </span>
            ))}
          </div>
          <div className="text-[14px] font-[400] text-center text-[#363636] leading-[1.6] break-keep whitespace-pre-wrap">
            {content.split('\n').map((line, i) => (
              <span key={i}>
                {line}
                {i === 0 && <br />}
              </span>
            ))}
          </div>
        </div>
        <div className="w-full flex items-center justify-center gap-[12px]">
          <Button
            variant="outlined"
            onClick={leftBtnClick}
            className="flex-1 h-[48px] rounded-[8px] bg-[#F8F8F8] text-[#969696] border-none"
            sx={{
              backgroundColor: '#F8F8F8 !important',
              color: '#969696 !important',
              border: 'none !important',
            }}
          >
            {leftBtnText}
          </Button>
          <Button
            variant="contained"
            onClick={rightBtnClick}
            className="flex-1 h-[48px] rounded-[8px]"
          >
            {rightBtnText}
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
